// src/data/comedians/jamel-debbouze.js

const base = {
  id: 'jamel-debbouze',
  slug: 'jamel-debbouze',
  name: 'Jamel Debbouze',
  birthYear: 1975,
  image: require('@/assets/images/img_Jamel_Debbouze.jpg'),
  famousWorks: [
    'Jamel Comedy Club',
    'Astérix & Obélix: Mission Cleopatra',
    'Days of Glory',
    'One-man shows',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'Moroccan-French',
    shortBio: 'Key figure in contemporary French comedy',
    bio: `Jamel Debbouze is a major figure in modern Moroccan-French comedy, known for his spontaneous style and socially driven humor rooted in personal experience. His ability to connect with audiences through his authentic voice has made him one of the most beloved comedians in France.\n\nBorn in Paris to Moroccan immigrant parents, Debbouze grew up in Trappes, a suburb of Paris, where his surroundings would heavily influence his comedic perspective. He rose to prominence through his unique ability to blend humor with social commentary about life in the French suburbs.\n\nAs the creator of the Jamel Comedy Club, he has helped launch the careers of many of today's top comedians, shaping the current comedy scene. He remains highly active in film, television, and live performances, cementing his legacy as a cultural bridge between communities.`,
    style: 'Spontaneous humor, social commentary, improvisation, suburban life',
    achievements: [
      'Creator of the Jamel Comedy Club',
      'César Award winner',
      'Influential cultural figure in France',
      'Launched careers of numerous comedians',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Marocain-Français',
    shortBio: 'Figure clé de la comédie française contemporaine',
    bio: `Jamel Debbouze est une figure majeure de la comédie franco-marocaine moderne, connu pour son style spontané et son humour socialement ancré dans l'expérience personnelle. Sa capacité à se connecter avec les audiences grâce à sa voix authentique en fait l'un des comédiens les plus aimés de France.\n\nNé à Paris de parents immigrés marocains, Debbouze a grandi à Trappes, une banlieue parisienne qui a fortement influencé sa perspective comique. Il s'est imposé grâce à sa capacité unique à mêler humour et commentaire social sur la vie en banlieue française.\n\nEn tant que créateur du Jamel Comedy Club, il a contribué à lancer les carrières de nombreux comédiens d'aujourd'hui, façonnant ainsi la scène comique actuelle. Il reste très actif au cinéma, à la télévision et dans les spectacles vivants.`,
    style: 'Humour spontané, commentaire social, improvisation, vie en banlieue',
    achievements: [
      'Créateur du Jamel Comedy Club',
      'César Award',
      'Figure culturelle influente en France',
      'A lancé les carrières de nombreux comédiens',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Marroquí-Francés',
    shortBio: 'Figura clave en la comedia francesa contemporánea',
    bio: `Jamel Debbouze es una figura importante en la comedia franco-marroquí moderna, conocido por su estilo espontáneo y su humor socialmente arraigado en la experiencia personal. Su capacidad para conectar con el público a través de su voz auténtica lo ha convertido en uno de los comediantes más queridos de Francia.\n\nNacido en París de padres inmigrantes marroquíes, Debbouze creció en Trappes, un suburbio de París, donde su entorno influiría fuertemente en su perspectiva cómica. Se hizo prominent gracias a su capacidad única para mezclar el humor con el comentario social sobre la vida en los suburbios franceses.\n\nComo creador del Jamel Comedy Club, ha contribuido a lanzar las carreras de muchos de los principales comediantes de hoy, dando forma a la escena cómica actual.`,
    style: 'Humor espontáneo, comentario social, improvisación, vida suburbana',
    achievements: [
      'Creador del Jamel Comedy Club',
      'Premio César',
      'Figura cultural influyente en Francia',
      'Lanzó las carreras de numerosos comediantes',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'مغربي-فرنسي',
    shortBio: 'شخصية محورية في الكوميديا الفرنسية المعاصرة',
    bio: `جمال دبوز شخصية بارزة في الكوميديا المغربية-الفرنسية الحديثة، اشتُهر بأسلوبه العفوي وفكاهته المجتمعية المستوحاة من التجربة الشخصية. قدرته على التواصل مع الجمهور بصوته الأصيل جعلت منه أحد أكثر الكوميديين محبوبيةً في فرنسا.\n\nوُلد في باريس لأبوين مهاجرَين مغربيَّين ونشأ في تراب، ضاحية من ضواحي باريس، حيث شكّلت البيئة المحيطة به منظوره الكوميدي بعمق. برز عبر قدرته الفريدة على المزج بين الفكاهة والتعليق الاجتماعي حول الحياة في ضواحي فرنسا.\n\nبوصفه مبتكر Jamel Comedy Club، أسهم في إطلاق مسيرة كثير من الكوميديين البارزين اليوم، مشكّلاً المشهد الكوميدي الراهن. ويبقى نشطًا جدًا في السينما والتلفزيون والعروض الحية.`,
    style: 'فكاهة عفوية، تعليق اجتماعي، ارتجال، حياة الضواحي',
    achievements: [
      'مبتكر Jamel Comedy Club',
      'جائزة César',
      'شخصية ثقافية مؤثرة في فرنسا',
      'أطلق مسيرة كوميديين عديدين',
    ],
  },
];
